// extracted by mini-css-extract-plugin
module.exports =  {"Collapse":"Collapse__j93ip","isOpened":"isOpened__305o-","actionAndTips":"actionAndTips__kzzqr","tips":"tips__xlPeB","action":"action__-FtOV","content":"content__YAO01"};